export default "__VITE_ASSET__Dwj8ltvC__"